import axios from 'axios'
export default {
    namespaced: true,
    state: {
		endpoint: '/catalog/vehicle/price',
		params: {},
		item: {
			type: {},
			currency: {},
		},
        items: [],
    },
    actions: {
		setItem(context, data) {
			context.commit('item', data ? data : {
				type: {},
				currency: {},
			})
		},
    }
}